import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Avatar, Container, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import my from '../Navbar/logo.png';


const Navbar = () => {
  const [showButtons, setShowButtons] = useState(false);

  const toggleButtons = () => {
    setShowButtons(!showButtons);
  };

  const handleButtonClick = () => {
    setShowButtons(false);
  };

  return (
    
    <AppBar position="fixed">
      <Container maxWidth="100%" sx={{ backgroundColor: 'black', color: 'white', boxShadow: '6px 7px 14px 1px cyan' }}>
      {/* #39FF14 */}
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            margin: 2,
            '@media (min-width:50px) and (max-width:600px)': {
              flexDirection: 'row',
              alignItems: 'center', 
            },
          }}
        >
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Avatar component='a'
                href='#home'  src={my} alt="Sriram" />
          </Typography>

          {(showButtons || window.innerWidth > 600) && (
            <div
              style={{
                display: 'flex',
                flexDirection: showButtons && window.innerWidth <= 600 ? 'column' : 'row', 
                alignItems: 'flex-start',
                marginLeft: { xs: 0, sm: 2 }, 
                marginRight: { xs: 0, sm: 2 },
              }}
            >
              <Button
              component='a'
                href='#about'
                style={{ textDecoration: 'none', color: 'inherit' }}
                sx={buttonStyles}
                onClick={handleButtonClick} 
              >
                About
              </Button>
              <Button
                component='a'
                href='#skills'
                style={{ textDecoration: 'none', color: 'inherit' }}
                sx={buttonStyles}
                onClick={handleButtonClick} 
              >
                Skills
              </Button>
              <Button
                component='a'
                href='#project'
                style={{ textDecoration: 'none', color: 'inherit' }}
                sx={buttonStyles}
                onClick={handleButtonClick} 
              >
                Projects
              </Button>
              <Button
                component='a'
                href='#cer'
                style={{ textDecoration: 'none', color: 'inherit' }}
                sx={buttonStyles}
                onClick={handleButtonClick}
              >
                Certification
              </Button>
              <Button
                component='a'
                href='#contact'
                style={{ textDecoration: 'none', color: 'inherit' }}
                sx={buttonStyles}
                onClick={handleButtonClick}
              >
                Contact
              </Button>
            </div>
          )}
          <IconButton
            color="inherit"
            aria-label="menu"
            onClick={toggleButtons}
            sx={{
              display: { xs: 'block', sm: 'none' }, 
              marginLeft: 1,
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

const buttonStyles = {
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      border: '3px solid',
      borderColor: 'yellow',
      zIndex: 1,
    },
    backgroundColor: 'transparent',
  },
  padding: '8px 16px',
  color: 'white',
  borderColor: 'primary.main',
};

export default Navbar;